import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={`py-16 md:py-24 px-6 md:px-12 max-w-5xl mx-auto ${className}`} data-id="element-178">
      {children}
    </motion.section>;
}